import { Grid, Paper, styled, withStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { PageTitle } from "./Typographies";
import { CustomLoading } from "../../assets/icons/GIFIcons";

const Page = styled("div")({
  overflow: "scroll",
  height: "calc(100vh - 48px)",
});

const PageHeader = withStyles({
  root: { height: "10.5vh", maxHeight: 64 },
  header: { zIndex: 3 },
})((props: any) => {
  const { children, classes, padding, style, ...otherProps } = props;
  let newStyle = {
    ...style,
    padding: Array.isArray(padding)
      ? padding
          .slice(0, 4)
          .map((val) => `${val}rem`)
          .join(" ")
      : `${padding}rem`,
  };

  return (
    <Paper square elevation={3} className={classes.header}>
      <Grid
        container
        item
        xs
        alignItems="center"
        {...otherProps}
        className={classes.root}
        style={newStyle}
      >
        {children}
      </Grid>
    </Paper>
  );
});

PageHeader.propTypes = {
  classes: PropTypes.any,
  children: PropTypes.node.isRequired,
  padding: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
};

PageHeader.defaultProps = {
  padding: 0,
};

interface PageLoadingProps {
  title?: string;
  actions?: () => JSX.Element;
  [property: string]: any;
}

const PageLoading = ({ title = "", actions, ...props }: PageLoadingProps) => (
  <Grid
    {...props}
    container
    item
    xs
    justifyContent="center"
    alignItems="center"
    direction="column"
  >
    <CustomLoading />
    <Typography variant="body1" style={{ fontWeight: 500 }}>
      {title}
    </Typography>
    {actions && actions()}
  </Grid>
);

export { Page, PageTitle, PageHeader, PageLoading };
